import Swiper from "swiper";

let isModalOpen = false;

const ModalCompanies = (mainSelectorName, theme) => {
	try {
		if($(mainSelectorName).length === 0) {
			return;
		}

		$(document).on('click', mainSelectorName, function () {
			let id = $(this).data('id');

			// loadModal($(this).data('modal-info'));

			if(id) {
				loadModal(id);
				$('body').addClass('modal-active');
				history.pushState({}, null, "");
				isModalOpen = true;
			}
		});

		$('.portfolio-modal, .portfolio-modal .close').on('click', function () {
			closeModal();
		});

		const closeModal = () => {
			$('.portfolio-modal').removeClass('show');
			$('body').removeClass('modal-active');
			isModalOpen = false;
		}

		window.addEventListener('popstate', function(event) {
			if (isModalOpen) {
				event.preventDefault();
				closeModal();
			}
		});

		$('.portfolio-modal-box').on('click', function (e) {
			e.stopPropagation();
		});

		const loadModal = (id) => {
			const companies = window.a16z_portfolio_companies;
			const data = companies.find(company => company.id == id);
			console.log(data);

			// Add check for exit stage
			const hasExit = Array.isArray(data.stage) && data.stage.includes('exit');

			let logoWidth = data.logo_width;
			let title = data.title;
			let socials = data.socials;
			let web = data.web;
			let email = data.email;
			let logo = data.logo;
			let yearFounded = data.year_founded;
			let investDate = data.invest_date;
			let exitDate = data.exit_date;
			let stages = data.stages;
			let isInitial = data.is_initial;
			let founders = data.founders;
			let overview = data.overview;
			let announcement = data.announcement;
			let jobs = data.jobs;
			let jobsLink = data.view_all_jobs_link;
			let allJobsLink = data.all_jobs_url;
			let articles = data.articles;
			let tickerSymbol = data.ticker_symbol;
			let acquirer = data.acquirer;

			const portfolioModal = $('.portfolio-modal');
			const portfolioModalContent = portfolioModal.find('.modal-content-inner');
			const portfolioModalSidebar = portfolioModal.find('.modal-aside');

			portfolioModalContent.html('');
			portfolioModalSidebar.html('');

			portfolioModalContent.html(`
				${overview ?
					`<div class="block">
							<h3>Company Profile</h3>
							${overview}
					</div>` : ''
				}

				${announcement.permalink ? 
					`<div class="block">
						<h3>Investment News</h3>
						<div class="minvest">
							<a href="${announcement.permalink}" class="card poppy p1">
								${logo ?
									`<div class="logo">
										<img src="${logo}" alt="${title}">
									</div>` : ''
								}
							</a>
							<div class="desc">
								${announcement.excerpt ? `<p>${announcement.excerpt}</p>` : ''}
								<a target="_blank" rel="noopener noreferrer" href="${announcement.permalink}" class="link">Read More</a>
							</div>
						</div>
					</div>` : ''
				}

				${(jobs || allJobsLink) ?
					`<div class="block">
						${jobs ?
							`<h3>Featured Jobs</h3>
							<div class="featured-jobs-slider swipper-container">
								<div class="swiper-wrapper">
										${jobs.slice(0, 3).map(generateJob).join('')}
								</div>
								<div class="swiper-pagination"></div>
							</div>` : ''
						}
						${allJobsLink ?
							`<div class="view-all">
								<a target="_blank" rel="noopener noreferrer" href="${allJobsLink}" class="link">View All Jobs</a>
							</div>` : ''
						}
					</div>` : ''
				}
				${articles.length ?
					`<div class="block">
						<h3>Featured Content</h3>
						<ul class="news-list">
								${articles.map(generateArticle).join('')}
						</ul>
					</div>` : ''
				}
			`);

			portfolioModalSidebar.html(`
				${logo ?
					`<div class="logo">
						${web ?
							`<a target="_blank" rel="noopener noreferrer" href="${web}">
								<img src="${logo}" width="${logoWidth}" alt="${title}">
							</a>` :
							`<img src="${logo}" width="${logoWidth}" alt="${title}">`
						}
					</div>` : ''
				}
				
				<div class="company-info">
					${(yearFounded || exitDate || tickerSymbol || (Array.isArray(stages) && stages.some(el => !!el))) ? 
						`<div class="info-list">
							<strong class="title">Milestones</strong>
							<ul class="list">
								${yearFounded ? 
									`<li><strong>Founded:</strong> ${yearFounded}</li>` : ''
								}
								${!hasExit && Array.isArray(stages) && stages.some(el => !!el) ?
									`<li><strong>${isInitial ? 'Stage at initial investment' : 'Current Stage'}:</strong> <span>${stages.join(', ')}</span></li>` : ''
								}
								${!hasExit && exitDate ? 
									`<li><strong>Exit:</strong> ${exitDate}</li>` : ''
								}
								${hasExit ? 
									`<li><strong>Exit</strong></li>` : 
									`${tickerSymbol ? `<li><strong>IPO:</strong> ${tickerSymbol}</li>` : ''}
									 ${acquirer ? `<li><strong>Acquirer:</strong> ${acquirer}</li>` : ''}`
								}
							</ul>
						</div>` : ''
					}
					<div class="right">
						${founders ? 
							`<div class="builders">
								<strong class="title">Builders</strong>
								<p>${founders}</p>
							</div>` : ''
						}
						<ul class="social-links">
							${socials ? socials.map(generateSocial).join('') : ''}
							${email ? `<li><a href="mailto:${email}" class="icon-email-rounded"></a></li>` : '' }
							${web ? `<li><a target="_blank" rel="noopener noreferrer" href="${web}" class="icon-monitor"></a></li>`: '' }
						</ul>
					</div>
				</div>
			`);

			if (jobs) {
				let swiperFeaturedJobs = new Swiper('.featured-jobs-slider', swiperOptions);
			}

			portfolioModal.addClass('show');
		}

		const generateSocial = (social) => {
			if (!social['constants.select.social_icons']) {
				// console.log('No "constants.select.social_icons" property found in social object:', social);
				return '';
			}

			return `
				<li>
					<a target="_blank" rel="noopener noreferrer" href="${social.url}" class="${social['constants.select.social_icons']['value']}"></a>
				</li>
			`;
		}

		const generateArticle = (article) => {
			return `
				<li>
					<h4><a href="${article.permalink}">${article.post_title}</a></h4>
					<div class="post-meta">
						<div class="author">${article.authors}</div>
					</div>
					<div class="txt">
						<p>${article.excerpt}</p>
					</div>
				</li>
			`;
		}

		const generateJob = (job) => {
			return `
				<div class="swiper-slide">
					<a href="${job.url ? job.url : '#'}" target="_blank" rel="noopener noreferrer" class="slide-box">
						<div class="box-content">
							<strong class="title">${job.title}</strong>
						</div>
					</a>
				</div>
			`;
		}

		const swiperOptions = {
			slidesPerView: 3,
			slidesPerGroup: 3,
			spaceBetween: 14,
			adaptiveHeight: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				540: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 14,
				},
				851: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 26,
				},
			},
		};
	} catch (e) {
		console.warn('ModalCompanies error', e)
	}
}

export default ModalCompanies;
